import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get organization
export const getOrganization = createAsyncThunk("organization/getOrganization", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.getOrganization({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue("Failed to get organization.");
  }
});

// get all organization
export const getAllOrganization = createAsyncThunk(
  "organization/getAllOrganization",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.getAllOrganization();
      return data;
    } catch (error) {
      return rejectWithValue("Failed to get organization.");
    }
  }
);

// get previous
export const getPrevious = createAsyncThunk("organization/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue("Failed to get organization.");
  }
});
// get next
export const getNext = createAsyncThunk("organization/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue("Failed to get organization.");
  }
});

// get particular page
export const getPageOrganization = createAsyncThunk(
  "organization/getPageOrganization",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;
    try {
      const { data } = await API.getPageOrganization({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue("Failed to get organization.");
    }
  }
);

// create organization
export const createOrganization = createAsyncThunk(
  "organization/createOrganization",
  async (data, { rejectWithValue, dispatch }) => {
    const { name, address, phoneNo1, phoneNo2, panVatNo, email, websiteUrl, favicon, logo, stamp, signature } = data;
    try {
      const body = new FormData();
      body.append("name", name);
      body.append("phoneNo1 ", phoneNo1);
      body.append("email", email);
      body.append("phoneNo2", phoneNo2);
      body.append("panVatNo", panVatNo);
      body.append("address", address);
      body.append("websiteUrl", websiteUrl);

      if (favicon) {
        body.append("favicon", favicon);
      }
      if (logo) {
        body.append("logo", logo);
      }
      if (stamp) {
        body.append("stamp", stamp);
      }
      if (signature) {
        body.append("signature", signature);
      }
      const { data } = await API.createOrganization(body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const updateOrganization = createAsyncThunk(
  "organization/updateOrganization",
  async (data, { rejectWithValue, dispatch }) => {
    const { id, values } = data;
    const { name, phoneNo1, email, phoneNo2, panVatNo, address, websiteUrl, logo, stamp, favicon, signature } = values;
    try {
      const body = new FormData();
      body.append("name", name);
      body.append("phoneNo1 ", phoneNo1);
      body.append("email", email);
      body.append("phoneNo2", phoneNo2);
      body.append("panVatNo", panVatNo);
      body.append("address", address);
      body.append("websiteUrl", websiteUrl);
      if (favicon) {
        body.append("favicon", favicon);
      }
      if (logo) {
        body.append("logo", logo);
      }
      if (stamp) {
        body.append("stamp", stamp);
      }
      if (signature) {
        body.append("signature", signature);
      }
      const { data } = await API.updateOrganization(id, body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// handle search
export const handleSearch = createAsyncThunk("organization/handleSearch", async (data, { rejectWithValue }) => {
  const { search, rowsPerPage } = data;
  try {
    const { data } = await API.handleSearch(search, rowsPerPage);
    return data;
  } catch (error) {
    return rejectWithValue("Failed to get organization");
  }
});
